import { useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { Modal, AutocompleteField, type AutocompleteFieldProps } from "@wayflyer/flyui";

export interface SelectionModalProps {
  title: string;
  selectLabel: string;
  options: AutocompleteFieldProps["options"];
  selectedItemId?: string | number;
  confirmLabel?: string;
  isOpen?: boolean;
  isLoading?: boolean;
  onConfirm(selectedItem: any): void;
  onCancel(): void;
  close?(): void;
  closeOnClickElseWhere?: boolean;
}

export const SelectionModal = ({
  title = "",
  selectLabel,
  options,
  selectedItemId,
  confirmLabel = "Confirm",
  isOpen = false,
  isLoading = false,
  closeOnClickElseWhere,
  onConfirm,
  onCancel,
  close,
}: SelectionModalProps) => {
  const intl = useIntl();
  const [selectedItem, setSelectedItem] = useState(selectedItemId);

  const handleConfirm = useCallback(() => {
    onConfirm(selectedItem);
  }, [onConfirm, selectedItem]);

  return (
    <Modal
      title={title}
      primaryAction={{ content: confirmLabel, loading: isLoading, onAction: handleConfirm, disabled: !selectedItem }}
      tertiaryAction={{
        content: intl.formatMessage({ id: "shared-ui: Cancel", defaultMessage: "Cancel" }),
        onAction: onCancel,
      }}
      isOpen={isOpen}
      onClose={close ?? onCancel}
      closeOnClickElseWhere={closeOnClickElseWhere}
    >
      <AutocompleteField
        name={selectLabel}
        label={selectLabel}
        placeholder={selectLabel}
        initialValue={selectedItemId}
        options={options}
        onChange={(id) => setSelectedItem(id)}
      />
    </Modal>
  );
};
